import {
  LayoutColumnsDefinition,
  LayoutListDefinition,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  TEXT,
  PHONE_NOTIFICATIONS,
  PhoneNotificationsDefinition,
  ItemIds,
  MESSAGE,
  MESSAGE_RESPONSE,
  TEXT_MESSAGES
} from '../items';
import { ItemDefinition } from '../items/Item';
import { Translator } from '../Translator';
import { translate } from './translate';
import { detectMultiSelect } from '~/training/sequence/templates/translators/itemHelpers/Quiz';

export const QuizPhoneNotification: Translator = sequence => {
  const columns = {
    type: LAYOUT_COLUMNS,
    id: `${sequence.id}-columns`,
    items: [],
    values: {}
  } as LayoutColumnsDefinition;
  const messages: ItemDefinition<ItemIds>[] = [];

  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'Phone':
        columns.items.push({
          id: item.id,
          type: LAYOUT_LIST,
          values: { align: 'left', height: { _: 'auto', lg: '100%' } },
          items: [
            {
              type: PHONE_NOTIFICATIONS,
              id: item.id,
              values: {
                picture: item.pictures && item?.pictures[0],
                name: item.title,
                content: item.body
              },
              items: [
                {
                  type: TEXT_MESSAGES,
                  id: '1',
                  items: messages,
                  values: {
                    value: '',
                    variant: 'default'
                  }
                }
              ]
            } as PhoneNotificationsDefinition
          ]
        } as LayoutListDefinition);
        break;

      case 'Text':
        columns.items.push({
          id: item.id,
          type: LAYOUT_LIST,
          values: { align: 'right', height: { _: 'auto', lg: '100%' } },
          items: [
            {
              type: TEXT,
              id: `${item.id}_subtitle`,
              items: [],
              values: {
                value: item.subtitle,
                variant: 'sub_heading',
                icon: item.icon
              }
            },
            {
              type: TEXT,
              id: `${item.id}_title`,
              items: [],
              values: {
                value: item.title,
                variant: 'heading1'
              }
            },
            {
              type: TEXT,
              id: `${item.id}_body`,
              items: [],
              values: {
                value: item.body
              }
            }
          ]
        } as LayoutListDefinition);
        break;

      case 'List': {
        const elementItems = item?.items ? item.items : [];
        elementItems?.forEach(element => {
          const valuesData = element.title ? { sender: element.title } : {};

          messages.push({
            type: MESSAGE,
            id: element.id,
            start: 0,
            values: valuesData,
            items: [
              {
                type: TEXT,
                id: `${element.id}_text`,
                items: [],
                values: {
                  value: element.body
                }
              }
            ]
          });
        });
        break;
      }

      case 'Question': {
        const elementItems = item?.items ? item.items : [];
        elementItems.forEach(element => {
          messages.push({
            type: MESSAGE_RESPONSE,
            id: element.id,
            values: {
              correct: element.correct,
              feedback: element.feedback,
              feedbackAudios: element.feedbackAudios?.[0],
              group: `group_${element.id}_${item.id}`,
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              llamaSurvey: element?.llamaSurvey,
              correctAnswers: detectMultiSelect(elementItems)
            },
            items: [
              {
                type: TEXT,
                id: `${element.id}_question`,
                items: [],
                values: { value: element.value }
              }
            ]
          });
        });
      }
    }

    return null;
  });

  root.items.push(columns);
  return root;
};
